import React from "react";

import ExternalComponent from "./ExternalComponent";
import Notification from "../components/search/Notification";

class SearchNotification extends ExternalComponent {
  updateSelf() {
    const self = this;
    const { results, searchDataLoading } = self.props;
    const { parentNode } = self.elementContainer;

    if (parentNode) {
      const button = parentNode.querySelector("a[role=button]");

      self.updateElement(
        <Notification
          key={self.id}
          results={results}
          searchDataLoading={searchDataLoading}
        />
      );

      if (results.length) {
        // TODO: re-enable when package cards have been changed
        //
        // if (results.some(result => result.package.book_online)) {
        //   button.innerText = "Book my golf holiday online";
        // }

        button.removeAttribute("hidden");
      } else {
        button.setAttribute("hidden", "");
      }
    }
  }
}

export default SearchNotification;



// WEBPACK FOOTER //
// ./providers/SearchNotification.jsx